import { ButtonHTMLAttributes, DetailedHTMLProps, ReactNode } from "react"

type IconButtonProps = {
  icon: ReactNode
  label?: string
  labelcolor?: string
} & DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>

export default function IconButton(props: IconButtonProps) {
  return (
    <>
      <style jsx>{`
        button {
          padding: 0.25rem;
          margin: 0;
          border: none;
          outline: none;
          background: transparent;
          display: flex;
          align-items: center;
          gap: 0.25rem;
          border-radius: 999px;
          transition: all 0.2s ease-in-out;
        }
        button:hover:not(:disabled) {
          background: var(--lightDarken);
          box-shadow: 0 0 0 0.25rem var(--light);
        }
        button:focus-visible {
          background: var(--light);
          box-shadow: 0 0 0 0.25rem var(--light);
          filter: brightness(90%);
        }
        button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        span {
          font-size: 1rem;
          font-weight: bold;
          color: ${props.labelcolor || "var(--dark)"};
        }
      `}</style>
      <button type="button" {...props}>
        {props.icon}
        {props.label && <span>{props.label}</span>}
      </button>
    </>
  )
}
